import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import BrandLogo from './LogoBranco.png'
// import BrandLogo from './logo_assinatura_BRANCO.png'

//  import styles from './HeaderView.scss'
import { Nav, Navbar, NavItem, NavDropdown, MenuItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

export class HeaderView extends React.Component {
  /*
  constructor (props) {
    super(props)
    // this.onMainStateToggle = this.onMainStateToggle.bind(this)
  }
  */

  getNavIndex(i, j) {
    return `${i}.${j}`;
  }

  renderSubMenus(menus, i) {
    return menus.map((lnk, j) => {
      let lnkTo = lnk.menu_url.toLowerCase();
      if (
        (lnk.internal_page_id === 0 && lnk.template_id === 5) ||
        lnkTo.indexOf("http") !== -1
      ) {
        return (
          <li key={j} role="presentation">
            <a
              key={this.getNavIndex(i, j)}
              role="menuitem"
              title=""
              href={lnk.menu_url}
              target="_blank"
            >
              {lnk.title}
            </a>
          </li>
        );
      } else {
        return (
          <LinkContainer key={j} to={{ pathname: "/" + lnk.menu_url }}>
            <MenuItem key={j} eventKey={this.getNavIndex(i, j)}>
              {lnk.title}
            </MenuItem>
          </LinkContainer>
        );
      }
    });
  }

  onMainStateToggle(evt, menuTitle) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  renderMenu() {
    const { top_menus } = this.props;

    return top_menus.map((lnk, i) => {
      let lnkTo = lnk.menu_url.toLowerCase();

      if (lnk.childs.length) {
        return (
          <NavDropdown
            key={i}
            eventKey={i}
            title={lnk.title}
            id="basic-nav-dropdown"
          >
            {this.renderSubMenus(lnk.childs, i)}
          </NavDropdown>
        );
      } else {
        if (lnkTo.indexOf("http") !== -1) {
          return (
            <li key={`li${i}`} role="presentation">
              <a
                key={`l${i}`}
                role="menuitem"
                title=""
                href={lnk.menu_url}
                target="_blank"
              >
                {lnk.title}
              </a>
            </li>
          );
        } else {
          return (
            <LinkContainer key={i} to={{ pathname: "/" + lnk.menu_url }}>
              <NavItem key={i} eventKey={i}>
                {lnk.title}
              </NavItem>
            </LinkContainer>
          );
        }

        /*
          return (
            <li role="presentation" style={{cursor: 'pointer'}}>
              <a onClick={(e) => this.onMainStateToggle(e, lowerTitle)}>{lnk.title}</a>
            </li>
          )
          */
      }
    });
  }
  // FCI_10a_branco //PT
  // /FCI_brasil_branco.png
  render() {
    return (
      <div id="main-hdr" className="row">
        <div id="hdr_main_nav" className="col-md-12 no-pad-right">
          <p />
          <Navbar>
            <Navbar.Header>
              <Navbar.Brand>
                <LinkContainer to={{ pathname: "/" }}>
                  <img src={process.env.PUBLIC_URL + '/images/logo.png'} />
                </LinkContainer>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav pullRight>{this.renderMenu()}</Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>
    );
  }
}

HeaderView.propTypes = {
  top_menus: PropTypes.array.isRequired,
  dispatch: PropTypes.func
};

function mapStateToProps(state, ownProps) {
  /*
  const {getMenus, selectedScope} = state

  const {
    isFetchingMenus,
    lastUpdatedMenus,
    items: menus
  } = getMenus[selectedScope] || {
    isFetchingMenus: true,
    items: {}
  }

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus
  }
  */
}

export default connect(mapStateToProps)(HeaderView);



// WEBPACK FOOTER //
// ./src/views/HeaderView/HeaderView.js